import type { ContestType } from '@betterpool/api-types/contests-service';

import { usePaginatedQuery } from '~/domains/common/hooks/usePaginatedQuery';

import { getContestSlates } from '../services/games-service.service.api';
import { STALE_TIME } from '~/domains/contest/constants/query';

function useContestSlates({
  scheduleId,
  contestType,
  finalSlateId,
  pageSize = 20,
  enabled = true,
}: {
  scheduleId?: string;
  contestType: ContestType;
  finalSlateId?: string;
  pageSize?: number;
  enabled?: boolean;
}) {
  return usePaginatedQuery(
    {
      queryKey: ['contestSlates', contestType, finalSlateId, scheduleId],
      queryFn: ({ limit, offset }) =>
        getContestSlates({
          scheduleId,
          contestType,
          finalSlateId,
          limit,
          offset,
        }),
      staleTime: STALE_TIME,
      enabled: !!scheduleId && enabled,
    },
    {
      pageSize,
    }
  );
}

export default useContestSlates;
